import React, { createContext, useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, track, identify, pageView, reset } from "@/lib/analytics";

const Ctx = createContext(null);

export function AnalyticsProvider({ children }) {
  const location = useLocation();

  useEffect(() => { initAnalytics(); }, []);

  useEffect(() => {
    // Fire on route change
    pageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  const value = useMemo(() => ({ track, identify, pageView, reset }), []);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAnalytics() {
  const c = useContext(Ctx);
  if (!c) return { track: () => {}, identify: () => {}, pageView: () => {}, reset: () => {} };
  return c;
}
